var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"front-layout"}},[_c('LayoutHeader'),_c('LayoutContent'),_c('LayoutFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }